import React, { useState, useEffect } from 'react';
import { useSecondScreenData } from '../../../contexts/SecondScreenContext';
import type { WidgetProps } from '../../../types/second-screen.types';

function formatElapsed(ms: number): string {
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

const TimerWidget: React.FC<WidgetProps> = () => {
  const { state, theme } = useSecondScreenData();
  const isDark = theme === 'dark';
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(interval);
  }, []);

  if (!state) return null;

  const sessionStart = state.sessionCreatedAt ? new Date(state.sessionCreatedAt).getTime() : now;
  const sessionElapsed = Math.max(0, now - sessionStart);

  return (
    <div className="flex flex-col items-center justify-center h-full gap-2 px-3">
      {/* Session elapsed */}
      <div className={`font-mono text-3xl font-bold tracking-wider ${
        isDark ? 'text-white' : 'text-slate-900'
      }`}
        style={isDark ? { textShadow: '0 0 20px rgba(0, 199, 196, 0.3)' } : {}}
      >
        {formatElapsed(sessionElapsed)}
      </div>

      {/* Phase label */}
      {state.phases[state.currentPhaseIndex] && (
        <div className={`text-xs font-medium ${isDark ? 'text-white/40' : 'text-slate-400'}`}>
          {state.phases[state.currentPhaseIndex].name}
        </div>
      )}
    </div>
  );
};

export default TimerWidget;
